import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import { Field, reduxForm, Form, change } from 'redux-form';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import { CircularProgress } from 'material-ui/Progress';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { Link, Prompt } from 'react-router-dom';

import renderTextField from '../../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../../helpers/ValidationHelper';
import normalizePhone from '../../../helpers/NormalizePhone';
import RenderDialog from '../../../helpers/RenderDialog';
import { removeWhiteSpace } from '../../../helpers/Util';

// import getPersonForEdit from '../../../actions/getPersonForEdit';
import updatePerson from '../../../actions/updatePerson';
import searchAllPages from '../../../actions/searchAllPages';
import getCustomers from '../../../actions/getCustomers';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import addUser from '../../../actions/addUser';

import LocationSelector from '../../../components/Customer/User/LocationSelector';

import Layout from '../../Layout';
import { roleIsAdmin, isSysAdmin } from '../../../helpers/security/roles';

import RenderConfirmationTimeoutDialog from '../../../helpers/RenderConfirmationTimeoutDialog';
import { ConsoleLogger } from '@aws-amplify/core';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  '@media only screen and (max-width: 1000px)': {
    card: {
      display: 'block'
    }
  },
  content: {
    flex: '1 0 auto',
  },
  content1: {
    flex: '1 0 auto',
    marginRight: '100px',
    marginLeft: '100px',
    marginTop: '10px',
    width: '500px'
  },
  paperStyle: {
    width: '90%',
    height: '100%',
    display: 'inline-block',
    margin: 20,
    marginTop: '20px'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    alignItems: 'center',
    width: '22%',
    marginLeft: '43%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  activityButtonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '22%',
    display: 'flex',
    justifyContent: 'center',
    minWidth: 123,
    height: 36,
    color: 'white',
    textTransform: 'capitalize'
  },
  '@media screen and (max-width: 900px)': {
    buttonStyle: {
      flexWrap: 'wrap',
      textAlign: 'center',
      marginLeft: '33%'
    },
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
  },
  textFieldSearch: {
    width: 350
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '2%',
    marginLeft: '9%',
    textAlign: 'left',
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  },
  toolTipStyle: {
    margin: '5%',
    width: '87.1%'
  },
  selectALocation: {
    textAlign: 'left',
    paddingLeft: '30%'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['email', 'firstName', 'lastName', 'password'], values);
  if (values.email && !validationHelper.validateEmail(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid phone number';
  }

  const lengthValidation = [
    { field: 'firstName', label: 'First Name', value: values.firstName, min: 1, max: 20 },
    { field: 'lastName', label: 'Last Name', value: values.lastName, min: 1, max: 30 },
    { field: 'suffix', label: 'Suffix', value: values.suffix, min: 1, max: 20 },
    { field: 'password', label: 'Password', value: values.password, min: 16, max: 25 },
    { field: 'email', label: 'Email Address', value: values.emailAddress, min: 1, max: 65 },
    { field: 'phoneNumber', label: 'Phone Number', value: values.phoneNumber, min: 1, max: 65 },
  ];
  validationHelper.validateLength(errors, lengthValidation);

  if (!errors.password && values.password && !validationHelper.validatePasswordSpecialRule(values.password)) {
    errors.password = 'Must contain 1 Uppercase, 1 Numerical and 1 Special Character';
  }
  return errors;
};

class AddEditUser extends Component {
  state = {
    saving: false,
    locationIds: [],
    fetching: true,
    person: null,
    searchFilter: '',
    buttonColor: '#002053',
    showRolesOnly: false,
    disabledLocation: '',
    persons: [],
    openDialog: false,
    disabledDialog: false,
    userEmail: '',
    showPrompt: <div />,
    password: '',
    userNameExists: false,
    message: null,
    activeButtonEnabled: true,
    locationsDisabled: null
  };

  async componentDidMount() {
    this.shouldPromptExist();
    const { customers, config, locationsList, personList, personLocations } = this.props.data;
    const { id } = this.props.match.params;
    if (id) {
      // if (this.props.locationsList && this.props.personLocations && customers && customers.customers) {
      if (locationsList && customers && personList && personLocations) {
        await this.props.actions.getLocations(config, id, customers.customers, personList.data, locationsList.data, personLocations.data, this);
        this.props.actions.getUsers(this.props.data.config, this);
      }
    } else {
      if (locationsList && customers && personList && personLocations) {
        await this.props.actions.getLocations(config, id, customers.customers, personList.data, locationsList.data, personLocations.data, this);
        this.props.actions.getUsers(this.props.data.config, this);
      }      
      this.disableFetch();
    }
  }

  disableFetch = () => {
    this.setState({ fetching: false });
}

//   componentDidUpdate(prevProps) {
//     const { customers, config, locationsList, personLocations } = this.props.data;
//     const { id } = this.props.match.params;
//     if (this.props.locationsList && this.props.personLocations && customers && customers.customers) {
//       this.props.actions.getLocations(config, id, customers.customers, locationsList.data, personLocations.data, this);
//       this.props.actions.getUsers(this.props.data.config, this);
//     }
// }  

  getRole = (location, person, useDefault) => {
    // for the selected location find what role the user has
    let role =
      person &&
      person.locations &&
      person.locations.filter(ll => ll.locationId === location) &&
      person.locations.filter(ll => ll.locationId === location)[0] &&
      person.locations.filter(ll => ll.locationId === location)[0].role;

    // if no existing role found, assing user role to the selected location
    if (!role && useDefault) {
      [role] = this.props.data.config.roles.filter(rol => rol.name === 'user');
    }

    return role;
  };

  handleCheckChange = (event) => {
    this.props.dispatch(change('AddEditUserForm', event.target.name, event.target.value));
  };

  handleSave = (event) => {
    const locations = this.state.person.locations.map(location => ({
      locationId: location.locationId, roleId: location.roleId
    }));

    this.setState({ buttonColor: '#ddd', showPrompt: <div />, saving: true });

    const userInfo = {
      personId: removeWhiteSpace(this.state.person.personId),
      firstName: removeWhiteSpace(event.firstName) || '',
      lastName: removeWhiteSpace(event.lastName) || '',
      suffix: removeWhiteSpace(event.suffix) || ' ',
      isActive: (this.state.person.isActive !== undefined ? this.state.person.isActive : true),
      email: removeWhiteSpace(event.email),
      personLocations: locations,
      password: event.password,
    };

    if (event.phoneNumber) {
      userInfo.phoneNumber = event.phoneNumber;
    }

    const saveUser = (this.state.person.email === event.email);

    if (saveUser && event.email === this.state.userEmail) {
      this.props.actions.saveUser(userInfo, this.props.data.config, this);
    } else if (!saveUser && event.email !== this.state.userEmail) {
      this.props.actions.saveUser(userInfo, this.props.data.config, this);
    } else {
      this.setState({ open: true });
    }
  };

  handleClose = (value) => {
    this.setState({ disabledDialog: false, open: false, openDialog: false, buttonColor: '#002053' });
  };

  removeRole = (locationId) => {
    const updatedLocations = this.state.person.locations.filter(loc => loc.locationId !== locationId);
    this.setState({ person: { ...this.state.person, locations: updatedLocations } });
  };

  canChangeRole = (roleId, locationId) => {
    if (isSysAdmin(this.props.data.person)) {
      return true;
    }

    return roleIsAdmin(this.props.data.person.locations.find(o => o.locationId === locationId).RoleId);
  };

  handleChangeRoleForLocation = (event) => {
    if (event && event.target && event.target.value) {
      const value = event.target.value.split(',');
      if (value) {
        const roleId = value[0];
        const locationId = value[1];

        if (!this.canChangeRole(roleId, locationId)) {
          return;
        }

        if (roleId === 'remove') {
          this.removeRole(locationId);
          return;
        }
        const changedRole = this.props.data.config.roles.find(o => o.roleId === roleId);

        const existingLocation = this.state.person && this.state.person.locations && this.state.person.locations.find(o => o.locationId === locationId);
        let updatedLocations = [];

        if (this.state.person && this.state.person.locations) {
          updatedLocations = [...this.state.person.locations.map((loc) => {
            if (loc.locationId === locationId) {
              return { ...loc, roleId: changedRole.roleId };
            }
            return loc;
          })];
        }
        if (!existingLocation) {
          const newLocation = { ...this.state.locationIds.find(o => o.locationId === locationId), roleId: changedRole.roleId };
          
          if (!newLocation.isActive) {
            this.setState({ disabledLocation: newLocation.locationName });
            return;
          }

          this.setState({ disabledLocation: '' });

          updatedLocations.push(newLocation);
        }

        this.setState({ person: { ...this.state.person, locations: updatedLocations } });
      }
    }
  };

  handleActivityChange = () => {
    let person =  this.state.person;

    if (person.isActive === false && person.customerRecordDisabled === true) {
      this.setState({ disabledDialog: true, message: "Customer account is deactivated" });
      return;
    }

    if (person.isActive === false && this.state.locationsDisabled === true) {
      this.setState({ disabledDialog: true, message: "User locations are deactivated" });
      return;
    }
    else {
    let prompt = window.prompt('You are about to modify the activity status of this user. Please type "confirm" to proceed.');
      if (prompt && prompt.toLowerCase() === 'confirm') {
      return this.setState({ person: { ...this.state.person, isActive: !this.state.person.isActive } });
      }
    }
  }

  handleChangeSearch = (event) => {
    this.setState({ searchFilter: event.target.value });
  };

  handleFilterSearch = (event) => {
    this.setState({ showRolesOnly: !this.state.showRolesOnly });
  };

  handleConfirmSaved = () => {
    return this.props.data.users.saved;
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value })
  };

  shouldPromptExist = () => {

    if (this.props.match.params.id) {
      const showPrompt = (<Prompt
        when={this.handleConfirmSaved()}
        message="Any changes will be lost if you leave this screen. Would you like to continue?"
      />);

      this.setState({ showPrompt })
    }
  };

  handleSearchUserName = (event) => {
    if (this.props.match.params.id && this.state.person.email === event.target.value) { return; }
    const userNameExists = validationHelper.checkValueExist('email', event.target.value, this.state.persons);
    this.setState({
      userNameExists
    });
  }

  handleAgree = () => {
    this.props.history.push('/users');
  }


  saveAlert = () => {
    let dialog = <div />;
    if (this.state.openDialog) {
      dialog =
        (<RenderConfirmationTimeoutDialog
          open={this.state.openDialog}
          stayInAction={() => { this.handleClose(); }}
          handleIdleTimeout={() => { this.handleAgree(); }}
          timeoutInterval={this.props.data.config.ConfirmationTimeout}
          page={this.props.match.params.id ? 'Edit User' : 'Add User'}
        />);
    } else {
      dialog = (<div />);
    }
    return dialog;
  }

  checkLocationStatus = () => {
    let activityList = [];
    let locations = this.state.person.locations;
    if (locations) {
      for (const loc of locations) {activityList.push(this.props.data.locationsList.data.find(item => item.locationId === loc.locationId).isActive)};
      if (!activityList.includes(true)) {
        this.setState({ locationsDisabled: true })
      }
    }
  }

  renderActivityButton = () => {
    const { classes } = this.props;
    const { activeButtonEnabled, locationsDisabled } = this.state;
    let locationId = localStorage.getItem('locationId');
    let locationList = JSON.parse(localStorage.getItem('person')).locations;
    let currentRole = locationList.filter(loc => loc.locationId === locationId)[0].role.name;
    let active;
    let activityButton;

    if (locationsDisabled === null && this.props.match.params.id) {
      this.checkLocationStatus();
    }
    if (this.state.person && this.props.match.params.id && currentRole !== 'user') {
      active = this.state.person.isActive;
      activityButton = <div style={{ justifyContent: 'center', display: 'flex', paddingTop: '10%'}}>
      {
        activeButtonEnabled &&
        (
          <Button
            variant="raised"
            className={classes.activityButtonStyle}
            style={ active ? { background: 'green' } : { background: 'red' }}
            onClick={ this.handleActivityChange }>
              { active ? 'Active' : 'Inactive' }
          </Button>
        )
      }
      </div>
    }
    return activityButton;
  }

  render() {
    const dialog = this.saveAlert();
    const { classes, handleSubmit, invalid } = this.props;
    const { searchFilter: searchTerm, showRolesOnly, disabledDialog, message } = this.state;
    const dis = this.props.match.params.id && false;
    let errors = invalid || !this.state.person;
    if (this.state.person) {
      if (!this.state.person.locations) {
        errors = true;
      }
      if (this.state.person.locations && this.state.person.locations.length === 0) {
        errors = true;
      }
    }

    let button = <div align="center"><CircularProgress size={75} /></div>;

    if (!this.state.fetching) {
      button = (<Button variant="raised"
      className={classes.buttonSize}
        style={(this.props.valid && this.state.person && this.state.person.locations && this.state.person.locations.length > 0) && !this.state.saving ? { background: this.state.buttonColor } : { background: '#ddd' }}
        disabled={!this.props.valid || !this.state.person || this.state.saving || (this.state.person && !this.state.person.locations) || (this.state.person && this.state.person.locations && this.state.person.locations.length === 0)}
        type="submit">{(this.state.buttonColor === '#ddd') ? 'Please wait...' : 'Save'}</Button>);
    }

    let dialogBox = <div />;

    if (this.state.open) {
      dialogBox = (<RenderDialog
        open
        confirmButton
        message="Username is already being used"
        onClose={this.handleClose}
      />);
    }

    let filteredLocations = this.state.locationIds.filter(o => (o.locationName && o.locationName.toUpperCase().includes(searchTerm.toUpperCase())) || (o.companyName && o.companyName.toUpperCase().includes(searchTerm.toUpperCase())));
    if (showRolesOnly && this.state.person && this.state.person.locations) {
      filteredLocations = this.state.locationIds.filter(o => this.state.person.locations.find(l => l.locationId === o.locationId));
    }
    return (
      <Layout className="App" showMenu menuTitle="" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.">
        <Paper className={classes.paperStyle}>
          {dialogBox}
          {dialog}
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title" className="lightH2">
                {this.props.match.params.id ? 'Edit User' : 'Add User'}
              </Typography>
              {this.state.showPrompt}
              <IconButton title="close" component={Link} to="/users">
                <Close color="disabled" />
              </IconButton>
            </Toolbar>
          </AppBar>
          {this.state.fetching && <div align="center"><CircularProgress size={75} /></div>}
          {!this.state.fetching &&
            <Form onSubmit={handleSubmit(this.handleSave)}>
              <Card className={classes.card} xs={12} sm={12}>
                <CardContent className={classes.content} style={{ marginTop: '20px' }}>
                  <Field
                    name="email"
                    disabled={dis}
                    component={renderTextField}
                    label="*Username / Email Address"
                    className={classes.textField}
                    divClassName={classes.marginStyle}
                    onChange={e => this.handleSearchUserName(e)}
                  />
                  <div
                    style={(!this.state.userNameExists ?
                      {display: 'none' } :
                      { display: 'block', color: 'red', fontSize: '0.75rem' })}
                  >
                    This username already exists
                  </div>
                  <Field
                    name="firstName"
                    component={renderTextField}
                    label="*First Name"
                    className={classes.textField}
                    divClassName={classes.marginStyle}
                  />
                  <Field
                    name="lastName"
                    component={renderTextField}
                    label="*Last Name"
                    className={classes.textField}
                    divClassName={classes.marginStyle}
                  />
                  <Field
                    name="suffix"
                    component={renderTextField}
                    label="Suffix"
                    className={classes.textField}
                    divClassName={classes.marginStyle}
                  />
                  <Field
                    name="phoneNumber"
                    normalize={normalizePhone}
                    component={renderTextField}
                    label="Phone Number"
                    className={classes.textField}
                    divClassName={classes.marginStyle}
                  />
                  {
                    !this.props.match.params.id &&
                    <Field
                      name="password"
                      component={renderTextField}
                      label="*Set Initial Password"
                      className={classes.textField}
                      divClassName={classes.marginStyle}
                      onChange={e => this.handlePasswordChange(e)}
                      password
                      data-tip="Password must contain at least 16 but not exceed 25 characters<br />Password must contain at least one number<br />Password must contain at least one special character<br />Password must contain at least one uppercase character"
                    />
                  }
                  {this.renderActivityButton()}
                  <ReactTooltip
                    place="bottom"
                    effect="solid"
                    multiline
                    event="focusin"
                    eventOff="focusout"
                  />
                </CardContent>
                <CardContent className={classes.content1}>
                  <p className={classes.selectALocation}>*Select a location</p>
                  <div className="user-search">
                    <TextField
                      id="search"
                      label="Search"
                      className={classes.textField}
                      value={this.state.searchFilter}
                      onChange={this.handleChangeSearch}
                      margin="normal"
                    />
                    <Checkbox onChange={this.handleFilterSearch} checked={this.state.showRolesOnly} label="Has Role" style={{ color: '#002053' }} />
                    Locations with role
                  </div>
                    {
                      this.state.disabledLocation &&
                      <span style={{ textAlign: 'left' }}>
                        <p style={{ color: 'red', fontSize: '1rem' }}>{this.state.disabledLocation} is disabled</p>
                      </span>
                    }
                  <div style={{ marginLeft: '-100px' }}>
                    <LocationSelector
                      locations={filteredLocations}
                      person={this.state.person}
                      changeRoleForLocation={this.handleChangeRoleForLocation}
                    />
                  </div>
                </CardContent>
              </Card>
              <div disabled className={classes.buttonStyle}>
                {button}
                {
                  message !== '' ? <RenderDialog
                  open={disabledDialog}
                  confirmButton
                  message={message}
                  onClose={this.handleClose}
                  /> : <div/>
                }
                <div className={`${classes.messageStyle} mandatory-msg` }>* Required fields</div>
              </div>
            </Form>
          }
        </Paper>
      </Layout>
    );
  }
}

AddEditUser.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    config: state.config.config,
    customers: state.customers,
    locations: state.search.locations,
    locationsList: state.search.locationsList,
    person: state.person.person,
    personLocations: state.search.personlocations,
    personList: state.search.persons,
    persons: state.persons,
    users: state.users
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    saveUser: (userInfo, config, self) => {
      // check to see if we need to create a cognito user
      if (!userInfo.personId) {
        const cognitoUserInfo = {
          userName: removeWhiteSpace(userInfo.email.toLowerCase()),
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          suffix: userInfo.suffix,
          email: removeWhiteSpace(userInfo.email.toLowerCase()),
          phoneNumber: normalizePhone(userInfo.phoneNumber),
          password: userInfo.password,
        };

        dispatch(addUser(cognitoUserInfo, config))
          .then((o) => {
            const cogUser = { ...userInfo, cognitoId: o.value.userSub, password: '' };
            delete cogUser.password;
            dispatch(updatePerson(cogUser, config)).then((result) => {
              dispatch(getCustomerGroups(config));
              dispatch(searchAllPages('person-locations', config));
              dispatch(searchAllPages('locations', config, true));
              dispatch(getCustomers(config));
              dispatch(searchAllPages('persons', config));
              self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
            });
          }).catch((error) => {
            self.setState({ buttonColor: '#002053' });
            dispatch({ type: 'SHOW_ERROR_DIALOG', payload: error });
          });
      } else {
        const cogUser = { ...userInfo, password: '' };
        delete cogUser.password;
        dispatch(updatePerson(cogUser, config)).then((o) => {
          dispatch(getCustomerGroups(config));
          dispatch(searchAllPages('person-locations', config))
          dispatch(searchAllPages('locations', config, true));
          dispatch(getCustomers(config));
          dispatch(searchAllPages('persons', config));
          self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
        });
      }
    },
    getCustomers: (config, self) => {
      dispatch(getCustomers(config)).then((o) => {
        if (o && o.value && o.value.data.customers) {
          const ids = o.value.data.customers.map(cust => ({ id: cust.customerId, displayText: cust.name }));
          self.setState({ customerIds: ids });
        }
      });
    },
    getLocations: (config, personId, customers, personList, locationsData, personLocations, self) => {
      self.setState({ fetching: true });
      // get all locations
      // dispatch(search('locations', 0, null, config)).then((locations) => {
        // get all customers
        // dispatch(getCustomers(config)).then((customers) => {
          self.setState({ fetching: false, buttonColor: '#002053' });

          // if (locations.value && locations.value.data && locations.value.data.tableName === 'locations') {
            // const { items } = locations.value.data;
            const items = locationsData;
            const customerItems = customers.customers;

            const defaultRole = '';

            // for all the locations on the logged in user, if any of them has sys admin role
            // then they have access to all locations
            // filter out the locations the user does not have permission to
            const locationItems = items.filter(location =>
              (roleIsAdmin(self.getRole(location.locationId, self.props.data.person, false)) ||
                isSysAdmin(self.props.data.person)));

            // create a list of locations with the customer name tagged on at the end
            // map the roles to a new object
            const mappedLocations = locationItems.map(location => ({
              locationId: location.locationId,
              customerId: location.customerId,
              locationName: location.locationName,
              isActive: location.isActive !== undefined ? location.isActive : true,
              companyName: customerItems.find(o => o.customerId === location.customerId) && customerItems.find(o => o.customerId === location.customerId).name,
              // create a default role for each location (user)
              role: defaultRole,
              name: `${location.locationName} - (${customerItems.filter(cust => cust.customerId === location.customerId)[0] ? customerItems.filter(cust => cust.customerId === location.customerId)[0].name : '<No customer Name>'})`
              }));

            // sort them
            mappedLocations.sort((a, b) => a.name.localeCompare(b.name));
            self.setState({ locationIds: mappedLocations });

            // see if we have a cognito id, if so, load the person
            if (personId) {
              const personIdVal = personList.filter(pl => pl.cognitoId === self.props.match.params.id)[0].personId;
              const personLocationResult = personLocations.filter(pl => pl.personId === personIdVal);
              const personListVal = personList.filter(pl => pl.personId === personIdVal);
              personListVal[0].personLocations = personLocationResult;
              const personResult = personListVal;
              const person = personListVal[0];
              person.locations = personLocationResult;
              self.setState({ persons: personResult });

              if ('customerRecordDisabled' in person && person.customerRecordDisabled) {
                self.setState({ activeButtonEnabled: !person.customerRecordDisabled });
              }

              self.setState({ fetching: false, userEmail: person.email });
              // now we need to manually set state for the form for certain elements (like multi selects etc)
              dispatch(change('AddEditUserForm', 'email', person.email));
              dispatch(change('AddEditUserForm', 'firstName', person.firstName));
              dispatch(change('AddEditUserForm', 'lastName', person.lastName));
              dispatch(change('AddEditUserForm', 'suffix', person.suffix));
              const phonenumber = (person.phoneNumber) ? person.phoneNumber.match(/\d/g).join('') : null;
              dispatch(change('AddEditUserForm', 'phoneNumber', (phonenumber && phonenumber.length === 10) ?
                normalizePhone(person.phoneNumber) : person.phoneNumber));
              self.setState({ person, errorAutoComplete: person.locations ? null : 'Locations are required' });
            }
    },
    getUsers: (config, self, personList) => {
      self.setState({ persons: personList });
    }
  }
});


const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddEditUserForm',
  enableReinitialize: true,
  validate
})(AddEditUser));

const ConnectedAddEditUserForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditUserForm;


// WEBPACK FOOTER //
// ./src/components/Customer/User/AddEditUser.js